<template>
  <v-data-table
    :headers="sharedHeaders"
    :items="shareWorkspaces"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    :items-per-page="-1"
    :hide-default-footer="true"
    item-key="TargetWorkspaceID"
    show-expand
    class="elevation-1"
  >
    <!--template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Contenido compartido</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
    </template-->
    <template v-slot:[`item.ident`]="{ item }">
      <a v-if="onEdit" @click="onEdit(item.ident.id)">{{ item.ident.name || item.ident.id }}</a>
      <span v-else>{{ item.ident.name || item.ident.id }}</span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" style="background-color: orange;">
        <div v-if="expanded.filter(x => x.ID === item.ID).length > 0">
          <detail :shareData="item" />
        </div>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import Detail from './Detail'
export default {
  name: 'ListWorkspaceShareContent',
  components: {
    Detail,
  },
  props: {
    forceRefres: {
      type: String,
      default: null,
    },
    workspaceID: {
      type: String,
      required: true,
    },
    shareWorkspaces: {
      type: Array,
      required: true,
    },
    onEdit: {
      type: Function,
      default: null,
    }
  },
  data: () => ({
    expanded: [],
    singleExpand: true,
  }),
  computed: {
    sharedHeaders () {
      return [
        {
          text: 'Target WorkspaceID',
          align: 'start',
          sortable: false,
          value: 'ident',
        },
        { text: '', value: 'data-table-expand' },
      ]
    },
  },
}
</script>
